<template>
	<div class="divide-y-2 divide-gray-200">
		<div class="p-6" v-if="creating">
			<p class="font-medium text-gray-700 text-lg">{{ __("Type of Offer") }}</p>

			<div class="flex space-x-6 mt-1 mb-4 text-lg">
				<ui-radio-group
					class="col-span-2"
					v-model="trade"
					radioValue="SELL"
					:key="'true-' + trade"
					name="trade"
					v-on:change="tradeChanged"
					>{{ __("Sell Offer") }}</ui-radio-group
				>
				<ui-radio-group
					class="col-span-2"
					v-model="trade"
					radioValue="BUY"
					:key="'BUY-' + trade"
					name="trade"
					v-on:change="tradeChanged"
					>{{ __("Buy Offer") }}</ui-radio-group
				>
			</div>
		</div>

		<div class="p-6 space-y-6">
			<div class="flex flex-wrap gap-x-6 gap-y-6">
				<ui-select-group
					class="basis-full sm:basis-[30.75%]"
					v-model="form.product.type"
					field="product.type"
					type="select"
					label="Article"
					:options="$cropOptions.productTypeOptions"
					:form="form"
					:required="true"
					:placeholder="false"
					v-on:change="productTypeChanged"
				></ui-select-group>

				<ui-select-group
					class="basis-full sm:basis-[30.75%]"
					v-model="form.product.grade"
					field="product.grade"
					type="select"
					label="Quality Grade"
					:options="currentProductGradeOptions"
					:form="form"
					:required="true"
					:placeholder="false"
					v-if="hasMultipleGrades"
					v-on:change="productGradeChanged"
				></ui-select-group>
			</div>

			<div class="flex flex-wrap gap-x-6 gap-y-6">
				<ui-select-group
					class="basis-full sm:basis-[30.75%]"
					v-model="form.product.harvest"
					field="product.harvest"
					type="select"
					label="Harvest Year"
					:options="harvestYearOptions"
					:form="form"
					:required="true"
					:placeholder="false"
				></ui-select-group>

				<ui-select-group
					class="basis-full sm:basis-[30.75%]"
					v-model="form.product.origin"
					field="product.origin"
					type="select"
					label="Origin"
					:options="
						$cropOptions.originOptions.filter((o) => !o.paperOnly === true)
					"
					:form="form"
					:required="true"
					:placeholder="false"
				></ui-select-group>

				<ui-check-group
					class="basis-full"
					v-if="showEditPriceIndication"
					:form="form"
					field="priceindication.enabled"
					v-model="form.priceindication.enabled"
					label="Enabled for Price Ticker"
				/>
			</div>
		</div>

		<offer-edit-quality
			class="p-6 min-h-[8.25rem]"
			v-if="form.product.grade != null"
			ref="editQuality"
			:form="form"
			:user="user"
			:creating="creating"
		/>
		<div v-else class="p-6 min-h-[8.25rem] space-y-2">
			<p class="block font-medium text-gray-700">{{ __("Quality") }}</p>
			<p>{{ __("Please choose an article first!") }}</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		creating: {
			type: Boolean,
			default: false,
		},
		showEditPriceIndication: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			trade: this.form.trade,
		};
	},
	computed: {
		currentProductGradeOptions: function () {
			let currentProductType = this.form.product.type;
			return currentProductType
				? this.$cropOptions.productGradeOptions[currentProductType]
				: [];
		},
		hasMultipleGrades: function () {
			return (
				this.currentProductGradeOptions &&
				this.currentProductGradeOptions.length > 1
			);
		},
		harvestYearOptions: function () {
			return this.$cropOptions.harvestYearOptions.map(function (i) {
				return { id: i, name: i };
			});
		},
	},
	methods: {
		productGradeChanged() {
			let that = this;
			//this.$nextTick(() => that.$refs.editQuality.qualityType = 'STANDARD')
			this.$nextTick(function () {
				that.$refs.editQuality.qualityType = "STANDARD";
				if (that.form.product.grade == "WHEAT_B__OTHER") {
					this.$nextTick(function () {
						that.$refs.editQuality.qualityType = "SPECIFIC";
					});
				}
			});
			console.log("PG CHANGED", this.qualityType);
		},
		productTypeChanged() {
			this.form.product.grade = null;

			if (!this.hasMultipleGrades) {
				this.form.product.grade = this.currentProductGradeOptions[0].id;
				this.productGradeChanged();
			}
		},
		tradeChanged(trade) {
			if (this.creating) {
				switch (trade) {
					case "SELL":
						this.form.location.mode = "FCA";
						break;
					case "BUY":
						this.form.location.mode = "DAP";
						break;
					default:
						console.log("WTF");
				}
			}
		},
		setQualityStandardIfParametersUnchanged() {
			let grade = this.form.product.grade,
				qualityStandardOptions = {};

			if (!grade) {
				return;
			}

			//collect all standard options, for B-Wheat collect all proteins together
			if (grade.startsWith("WHEAT_B__")) {
				qualityStandardOptions = this.$cropOptions.qualityStandardOptions;
				Object.keys(qualityStandardOptions).forEach((key) => {
					qualityStandardOptions[key][0].grade = key;
				});
				qualityStandardOptions = Object.values(qualityStandardOptions)
					.flat()
					.filter((o) => o.name.startsWith("B-Wheat"));
			} else {
				qualityStandardOptions =
					this.$cropOptions.qualityStandardOptions[grade];
			}
			//in case Specific Quality was chosen, we need to check if it differs from Standard
			if (this.form.product.quality_standard_id == null) {
				//loop over qualityStandardOptions
				for (let index = 0; index < qualityStandardOptions.length; ++index) {
					const qualityStandard = qualityStandardOptions[index];

					//if quality is not specific, we assign its Standard Quality id
					if (this.allQualityAttributesEqualStandard(qualityStandard)) {
						this.form.product.quality_standard_id = qualityStandard.id;
						//in case of B-Wheat also change the product grade
						if (grade.startsWith("WHEAT_B__")) {
							this.form.product.grade = qualityStandard.grade;
						}
						//Break once we found it
						break;
					}
				}
			}
		},
		allQualityAttributesEqualStandard(item) {
			const checkboxIds = this.$cropOptions
				.getProductQualityParameters(
					this.form.product.type,
					this.form.product.grade
				)
				.filter((parameter) => parameter.type === "checkbox")
				.map((parameter) => parameter.id);

			// Checkbox: nicht gesetzt (null) heißt "Nein" — weicht von einem Standard mit "Ja" ab und umgekehrt.
			for (const id of checkboxIds) {
				if ((this.form.quality[id] == 1) !== (item[id] == 1)) {
					return false;
				}
			}

			for (const property in item) {
				if (checkboxIds.includes(property)) {
					continue;
				}

				if (
					this.form.quality.hasOwnProperty(property) &&
					this.form.quality[property] != null &&
					item[property] != this.form.quality[property]
				) {
					// this attribute was changed from the standard
					return false;
				}
			}
			// each quality attribute in the form agrees with the standard
			return true;
		},
	},
	beforeDestroy() {
		this.setQualityStandardIfParametersUnchanged();
	},
	created() {
		this.tradeChanged();
	},
	watch: {
		trade(newValue) {
			this.form.trade = newValue;
			if (newValue == "BUY") {
				console.log(this.$page.url + "&trade=BUY");
				this.$inertia.visit(this.$page.url + "&trade=BUY", {
					method: "get",
					preserveScroll: true,
				});
			}
		},
	},
};
</script>
